import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { Endpoints } from 'src/app/core/resources/endpoints';
import { FirebaseApi } from 'src/app/core/classes/firebase-api';
import { MinistryMonitor, MinistryStateRecord } from 'src/app/core/interfaces/ministry-monitor';

@Injectable({
  providedIn: 'root'
})
export class MinistryMonitorService {

  private currentStatusSubject = new BehaviorSubject<MinistryMonitor | null>(null);
  public currentStatus$: Observable<MinistryMonitor | null> = this.currentStatusSubject.asObservable();

  private unsubscribe: () => void;
  private listening = false;

  constructor(
    private http: HttpClient,
    private endpoints: Endpoints
  ) {}

  public startListener(): void {
    if (this.listening) {
      console.log('[MinistryMonitor] listener ya activo, skip');
      return;
    }
    console.log('[MinistryMonitor] iniciando listener Firestore en MinistryMonitor/current');
    try {
      const ref = FirebaseApi.root.firestore.collection('MinistryMonitor').doc('current');
      console.log('[MinistryMonitor] ref creada:', ref.path);
      this.unsubscribe = ref.onSnapshot(
        (snapshot) => {
          console.log('[MinistryMonitor] snapshot recibido — exists:', snapshot.exists, '| data:', snapshot.data());
          if (snapshot.exists) {
            this.currentStatusSubject.next(snapshot.data() as MinistryMonitor);
          }
        },
        (err) => {
          console.error('[MinistryMonitor] error en listener Firestore:', err);
          this.currentStatusSubject.next(null);
        }
      );
      this.listening = true;
      console.log('[MinistryMonitor] listener registrado OK');
    } catch (e) {
      console.error('[MinistryMonitor] excepción al crear listener:', e);
    }
  }

  public stopListener(): void {
    if (this.unsubscribe) {
      this.unsubscribe();
      this.unsubscribe = null;
    }
    this.listening = false;
  }

  public getHistory(limit: number = 50): Promise<MinistryStateRecord[]> {
    return this.http.get<MinistryStateRecord[]>(
      `${environment.urlServerTeclogi}${this.endpoints.ministryStatusHistory}?limit=${limit}`
    ).toPromise();
  }
}
